import { useRecovery } from '../../model'
import { Fieldset } from '@/common/ui/Form/Fieldset/Fieldset'
import { Input } from '@/common/ui/Form/Input/Input'
import { Button } from '@/common/ui/Form/Button'
import { AuthTabs } from '../shared/AuthTabs'
import { EMAIL_VALIDATION } from '@/common/ui/Form/Input'

export const RecoveryForm = () => {
    const { register, handleSubmit, errors, onSubmit, mutation } = useRecovery()

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            aria-label='Форма восстановления пароля'
            className='w-full flex flex-col gap-[1.875rem]'
        >
            <AuthTabs />
            <Fieldset errorText={errors.email?.message} required>
                <span className='block text-[1.25rem] mb-[0.938rem]'>Сброс пароля</span>
                <Input
                    size='lg'
                    type='text'
                    placeholder='Email'
                    className='w-full'
                    required
                    aria-label='Email'
                    {...register('email', {
                        required: EMAIL_VALIDATION.required,
                        pattern: EMAIL_VALIDATION.pattern,
                    })}
                />
            </Fieldset>
            {errors.root && <div className='input-error text-center text-sm'>{errors.root.message}</div>}
            <Button
                type='submit'
                variant='filled'
                emphasis='accent'
                size='xl'
                className='w-full'
                aria-label='Отправить ссылку'
                disabled={mutation.isPending}
                loading={mutation.isPending}
            >
                Отправить ссылку
            </Button>
        </form>
    )
}
